function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 0.206894,
  width: 37,
  height: 37,
  rx: 8,
  fill: "#2C293E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.8902 12.8461C12.3568 12.7032 11.8084 13.0198 11.6655 13.5532L9.72435 20.7977C9.58141 21.3311 9.898 21.8795 10.4315 22.0224L24.5581 25.8077C25.0916 25.9506 25.6399 25.634 25.7829 25.1005L27.724 17.8561C27.867 17.3226 27.5504 16.7743 27.0169 16.6314L12.8902 12.8461ZM21.783 20.1465C21.3303 21.8358 19.5939 22.8383 17.9046 22.3857C16.2153 21.933 15.2128 20.1966 15.6654 18.5073C16.1181 16.818 17.8545 15.8155 19.5438 16.2681C21.2331 16.7208 22.2356 18.4572 21.783 20.1465Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.4116 14.5769C10.8593 14.5769 10.4116 15.0246 10.4116 15.5769V23.0769C10.4116 23.6292 10.8593 24.0769 11.4116 24.0769H26.0366C26.5889 24.0769 27.0366 23.6292 27.0366 23.0769V15.5769C27.0366 15.0246 26.5889 14.5769 26.0366 14.5769H11.4116ZM21.8908 19.3269C21.8908 21.0758 20.473 22.4936 18.7241 22.4936C16.9752 22.4936 15.5575 21.0758 15.5575 19.3269C15.5575 17.578 16.9752 16.1602 18.7241 16.1602C20.473 16.1602 21.8908 17.578 21.8908 19.3269ZM18.7241 20.9102C19.5986 20.9102 20.3075 20.2013 20.3075 19.3269C20.3075 18.4524 19.5986 17.7436 18.7241 17.7436C17.8497 17.7436 17.1408 18.4524 17.1408 19.3269C17.1408 20.2013 17.8497 20.9102 18.7241 20.9102Z",
  fill: "white"
});

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.26516eec.svg";
export { ForwardRef as ReactComponent };